"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const _withScopeId = (n) => ((0, vue_2.pushScopeId)("data-v-15e97fac"), n = n(), (0, vue_2.popScopeId)(), n);
const _hoisted_1 = { class: "req-button-wrapper" };
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("i", { class: "icon icon-edit" }, null, -1 /* HOISTED */));
const _hoisted_3 = [
    _hoisted_2
];
const _hoisted_4 = { class: "weeky-alloc-table-wrapper" };
const _hoisted_5 = { class: "table text-center role-table day-table weeky-alloc-table" };
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("thead", null, [
    /*#__PURE__*/ (0, vue_2.createElementVNode)("tr", null, [
        /*#__PURE__*/ (0, vue_2.createElementVNode)("th", { class: "th-holiday" }, "日"),
        /*#__PURE__*/ (0, vue_2.createElementVNode)("th", null, "月"),
        /*#__PURE__*/ (0, vue_2.createElementVNode)("th", null, "火"),
        /*#__PURE__*/ (0, vue_2.createElementVNode)("th", null, "水"),
        /*#__PURE__*/ (0, vue_2.createElementVNode)("th", null, "木"),
        /*#__PURE__*/ (0, vue_2.createElementVNode)("th", null, "金"),
        /*#__PURE__*/ (0, vue_2.createElementVNode)("th", { class: "th-saturday" }, "土"),
        /*#__PURE__*/ (0, vue_2.createElementVNode)("th", { class: "th-holiday" }, "祝")
    ])
], -1 /* HOISTED */));
const _hoisted_7 = { class: "tr-day-numbers" };
const _hoisted_8 = ["onUpdate:modelValue"];
const _hoisted_9 = { key: 1 };
const vue_3 = require("vue");
const roles_1 = require("../../js/roles");
exports.default = (0, vue_1.defineComponent)({
    __name: 'RoleRequiredWeekly',
    setup(__props) {
        const role = (0, vue_3.inject)("roleView");
        async function handleDayNumberSubmit() {
            if (!role) {
                return;
            }
            isEditing.value = false;
            await (0, roles_1.handleRoleDayRequiredUpdate)(role.value.id, dayNumComputed.value);
            (0, roles_1.updateRequiredCalendar)(dayNumComputed.value);
        }
        const isEditing = (0, vue_3.ref)(false);
        const dayNumbers = (0, vue_3.ref)([0, 0, 0, 0, 0, 0, 0, 0]);
        const dayNumComputed = (0, vue_3.computed)(() => {
            const out = [...dayNumbers.value];
            if (!role?.value.requiredWeekdayNumbers) {
                return out;
            }
            role.value.requiredWeekdayNumbers.forEach((d, i) => {
                out[i] = d;
            });
            return out;
        });
        return (_ctx, _cache) => {
            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)(vue_2.Fragment, null, [
                (0, vue_2.createElementVNode)("div", _hoisted_1, [
                    (!isEditing.value)
                        ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("button", {
                            key: 0,
                            onClick: _cache[0] || (_cache[0] = ($event) => (isEditing.value = true)),
                            class: "btn"
                        }, _hoisted_3))
                        : ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("button", {
                            key: 1,
                            onClick: handleDayNumberSubmit,
                            class: "btn btn-primary"
                        }, " 完了 "))
                ]),
                (0, vue_2.createElementVNode)("div", _hoisted_4, [
                    (0, vue_2.createElementVNode)("table", _hoisted_5, [
                        _hoisted_6,
                        (0, vue_2.createElementVNode)("tbody", null, [
                            (0, vue_2.createElementVNode)("tr", _hoisted_7, [
                                ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)(dayNumComputed.value, (requiredNum, weekdayNum) => {
                                    return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("td", null, [
                                        (isEditing.value)
                                            ? (0, vue_2.withDirectives)(((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("input", {
                                                key: 0,
                                                class: "form-input text-center",
                                                size: "3",
                                                type: "number",
                                                min: "0",
                                                "onUpdate:modelValue": ($event) => ((dayNumComputed.value[weekdayNum]) = $event),
                                                onKeyup: (0, vue_2.withKeys)(handleDayNumberSubmit, ["enter"])
                                            }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_8)), [
                                                [vue_2.vModelText, dayNumComputed.value[weekdayNum]]
                                            ])
                                            : ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("span", _hoisted_9, (0, vue_2.toDisplayString)(dayNumComputed.value[weekdayNum]), 1 /* TEXT */))
                                    ]));
                                }), 256 /* UNKEYED_FRAGMENT */))
                            ])
                        ])
                    ])
                ])
            ], 64 /* STABLE_FRAGMENT */));
        };
    }
});
